<mat-card class="card-size  element" [ngClass]="{'disabled-card':disabled}">
  @if (iotDeviceConfiuration!=null) {
    <div class="text-container">
      <mat-card-title style="max-width: calc(100% - 80px)">{{iotDeviceConfiuration.objectId}}</mat-card-title>
      <mat-card-subtitle>{{iotDeviceConfiuration.ricevuto}}</mat-card-subtitle>
      <div class="button-card-sovrapossition">
        <ng-content select="[button]">
        </ng-content>
      </div>
    </div>
    <div class="flex-start-center w100 flex-direction-row">
      @if (iotDeviceConfiuration.creation_date) {
        <div class="flex-start-start flex-direction-column text-container">
          <div class="text-child">{{'createdAt'|translate}}</div>
          <div>{{iotDeviceConfiuration.creation_date|customDate:'medium'|async}}</div>
        </div>
      }
      @if (iotDeviceConfiuration.last_edit_date) {
        <div class="flex-start-start flex-direction-column text-container"
          >
          <div class="text-child">{{'updatedAt'|translate}}</div>
          <div>{{iotDeviceConfiuration.last_edit_date|customDate:'medium'|async}}</div>
        </div>
      }
    </div>
  }
</mat-card>
